export const typography = {
  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  weight: { regular: 400, medium: 500, semibold: 600 },
  display: { fontSize: "32px", fontWeight: 600, lineHeight: "40px" },
  h1: { fontSize: "24px", fontWeight: 600, lineHeight: "32px" },
  h2: { fontSize: "20px", fontWeight: 600, lineHeight: "28px" },
  h3: { fontSize: "16px", fontWeight: 500, lineHeight: "24px" },
  bodyLg: { fontSize: "15px", fontWeight: 400, lineHeight: "24px" },
  body: { fontSize: "14px", fontWeight: 400, lineHeight: "22px" },
  bodyStrong: { fontSize: "14px", fontWeight: 500, lineHeight: "22px" },
  bodySm: { fontSize: "13px", fontWeight: 400, lineHeight: "20px" },
  label: { fontSize: "13px", fontWeight: 500, lineHeight: "18px" },
  labelSm: { fontSize: "12px", fontWeight: 500, lineHeight: "16px" },
  button: { fontSize: "14px", fontWeight: 600, lineHeight: "20px" },
  caption: { fontSize: "12px", fontWeight: 400, lineHeight: "16px" },
  overline: { fontSize: "11px", fontWeight: 600, lineHeight: "16px", letterSpacing: "0.08em", textTransform: "uppercase" },
};

export default typography;
